module.exports = __webpack_public_path__ + "img/qr-code.644a5f10.jpg";